<template>
  <section class="invoice-preview-wrapper">
    <b-row class="invoice-preview">
      <b-col cols="12">
        <b-card no-body class="invoice-preview-card px-1" id="invoice-preview-card">
          <!-- Header -->
          <b-card-body class="pb-0 px-0">
            <div class="row align-items-center mb-2">
              <div class="col-3">
                <Logo />
              </div>
              <div class="col-9">
                <div class="">
                  <CompanyName />
                </div>
                <div class="">
                  <Address />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <!-- Header: Left Content -->

                <div>
                  <h4 class="mb-1">Customer</h4>

                  <!-- Selected Client -->
                  <div class="mt-1">
                    <b-card-text v-if="custName" class="mb-25">Customer ABC</b-card-text>
                    <b-card-text v-if="custAddress" class="mb-25">Some Road, Somewhere</b-card-text>
                    <b-card-text v-if="custAddress" class="mb-25">City X</b-card-text>
                    <b-card-text class="mb-25">123000</b-card-text>
                    <b-card-text class="mb-0">customer1@gmail.com</b-card-text>
                  </div>
                </div>
              </div>
              <div class="col-6 text-right">
                <!-- Header: Right Content -->
                <h4 v-if="invoiceNo" class="invoice-title mb-1">
                  Invoice No
                  <span class="invoice-number">#INV1041</span>
                </h4>

                <div class="text-right">
                  <div v-if="invoiceDate" class="row invoice-date-wrapper">
                    <div class="col-md-6 col-6 d-flex justify-content-end">
                      <p class="invoice-date-title">Created On:</p>
                    </div>
                    <div class="col-md-6 col-6">
                      <p class="invoice-date">
                        {{ formatDate(currentDate()) }}
                      </p>
                    </div>
                  </div>

                  <div v-if="dueDate" class="row invoice-date-wrapper">
                    <div class="col-md-6 col-6 d-flex justify-content-end">
                      <p class="invoice-date-title">Due Date:</p>
                    </div>
                    <div class="col-md-6 col-6">
                      <p class="invoice-date">
                        {{ formatDate(addDays(currentDate(), 3)) }}
                      </p>
                    </div>
                  </div>

                  <div v-if="salesRep" class="row invoice-date-wrapper">
                    <div class="col-md-6 col-6 d-flex justify-content-end">
                      <p class="invoice-date-title">Salesperson:</p>
                    </div>
                    <div class="col-md-6 col-6">
                      <p class="invoice-date">Salesperson 1</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"></div> -->
          </b-card-body>
          <!-- Spacer -->

          <!-- Invoice Description: Table -->
          <div class="mt-3">
            <b-table-lite border responsive :items="products" :fields="[
              ...(productImage ? [{ key: 'productImage', label: 'Product Image' }] : []),
              { key: 'itemName', label: 'Product Name' },
              { key: 'description', label: 'Description' },
              { key: 'quantity', label: 'Quantity' },
              { key: 'price', label: 'Unit Price' },
              { key: 'cost', label: 'Total Cost' },
            ]" >
            <template #cell(productImage)="data">
              <!-- Display an image if the productImage field is present -->
              <img :src="data.item.productImageUrl" alt="Product Image" style="max-width: 50px; height: auto;" />
            </template>
          </b-table-lite>
          </div>
          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding px-0 pb-0">
            <b-row>
              <b-col cols="12" md="6" class="mt-md-0 mt-3" order="2" order-md="1">
                <b-card-text v-if="notes" class="mb-0">
                  <span class="font-weight-bold">Note: </span>
                  <span>lorem ipsum</span>
                </b-card-text>
              </b-col>

              <b-col cols="12" md="6" class="mt-md-6 d-flex justify-content-end" order="1" order-md="2">
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Subtotal:</p>
                    <p class="invoice-total-amount">Rs 614.00</p>
                  </div>
                  <div v-if="taxAmount" class="invoice-total-item">
                    <p class="invoice-total-title">VAT:</p>
                    <p class="invoice-total-amount">Rs 0.00</p>
                  </div>
                  <!-- <div class="invoice-total-item">
                    <p class="invoice-total-title">Discount:</p>
                    <p class="invoice-total-amount">Rs 0.00</p>
                  </div> -->
                  <hr class="my-50" />
                  <div v-if="totalAmount" class="invoice-total-item">
                    <p class="invoice-total-title">Total:</p>
                    <p class="invoice-total-amount">Rs 614.00</p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Total Paid:</p>
                    <p class="invoice-total-amount">Rs 614.00</p>
                  </div>
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">Balance:</p>
                    <p class="invoice-total-amount">Rs 0.00</p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Payments -->
          <b-card v-if="paymentTerms" title="Payments">
            <b-table responsive class="table-payment" :items="paymentData" :fields="[
              { key: 'settlementDate', label: 'Settlement Date' },
              { key: 'amountPaid', label: 'Amount Paid' },
            ]" />
          </b-card>

          <!-- Delivery Notes -->
          <!-- <b-card title="Delivery Notes">
            <b-table
              responsive
              class="table-delivery"
              :items="deliveryNotesData"
              :fields="[
                { key: 'product', label: 'Product' },
                { key: 'deliveryDate', label: 'Last Delivery Date' },
                { key: 'note', label: 'Note' },
                { key: 'actions', label: 'Actions' },
              ]"
            >
              <template #cell(actions)="data">
                <b-button
                  variant="primary"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  >View Signature</b-button
                >
              </template>
</b-table>
</b-card> -->

          <!-- Signature Section -->
          <!-- <div class="row mx-2">
            <div class="col-4">
              <h4 class="mb-4 text-center">Received By:</h4>
              <input type="text" id="signature" />
            </div>
            <div class="col-4">
              <h4 class="mb-4 text-center">Signature:</h4>
              <input type="text" id="signature" />
            </div>
            <div class="col-4">
              <h4 class="mb-4 text-center">Date:</h4>
              <input type="text" id="signature" />
            </div>
          </div> -->
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BTable,
  BTableLite,
  BCardText,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import Logo from "@core/layouts/components/Logo.vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTable,
    BTableLite,
    BCardText,
    BButton,
    BSpinner,
    Logo,
    Address,
    CompanyName,
  },
  props: {
    custAddress: {
      type: Boolean,
      default: false,
    },
    custName: {
      type: Boolean,
      default: false,
    },
    dueDate: {
      type: Boolean,
      default: false,
    },
    invoiceDate: {
      type: Boolean,
      default: false,
    },
    invoiceNo: {
      type: Boolean,
      default: false,
    },
    notes: {
      type: Boolean,
      default: false,
    },
    paymentTerms: {
      type: Boolean,
      default: false,
    },
    salesRep: {
      type: Boolean,
      default: false,
    },
    taxAmount: {
      type: Boolean,
      default: false,
    },
    totalAmount: {
      type: Boolean,
      default: false,
    },
    productImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      products: [
        {
          productImageUrl: "https://img.freepik.com/free-vector/product-quality-concept-illustration_114360-7461.jpg",
          itemName: "Product 1",
          description: "lorem",
          quantity: 5,
          price: "Rs 122.80",
          discount: "Rs 0.00",
          cost: "Rs 614.00",
        },
      ],
      paymentData: [
        {
          settlementDate: "2024-07-23T00:00:00",
          amountPaid: "Rs 395.00",
        },
        {
          settlementDate: "2024-07-23T00:00:00",
          amountPaid: "Rs 219.00",
        },
      ],
      deliveryNotesData: [
        {
          product: "Product 1",
          deliveryDate: "2024-08-23T00:00:00",
          note: "note 1",
        },
        {
          product: "Product 2",
          deliveryDate: "2024-08-12T00:00:00",
          note: "note 2",
        },
      ],
    };
  },
  methods: {
    currentDate() {
      return new Date();
    },
    formatDate(date) {
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    addDays(date, days) {
      const result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

#signature {
  width: 100%;
  border: 0px;
  border-bottom: 0.5px solid black;
  height: 0.5px;
}
</style>
